import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { CreatePollService } from "../../create-poll.service";
import { ITeam } from "@teammood/team";

@Component({
    selector: 'target-preview',
    templateUrl: 'target-preview.component.html',
    styleUrls: ['./target-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TranslateModule,
    ]
})
export class TargetPreviewComponent implements OnChanges{

    protected showAllTeams = false;
    protected recipients: number; 

    @Input() selectedTeams: ITeam[];
  
    constructor(
        private createPollService: CreatePollService
    ) {}

    async ngOnChanges(changes: SimpleChanges) {
        if(changes.selectedTeams?.currentValue){
            this.selectedTeams = changes.selectedTeams.currentValue;
            const teamIds = this.selectedTeams.map(team => team.id);
            this.recipients = await this.createPollService.getPollRecipients(teamIds);
            this.showAllTeams = this.selectedTeams.length <= 3;
        }
    }

}

